import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer, MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { IPaginationResult } from 'app/common/interfaces';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';
import { getCode } from 'app/utils/method';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { debounceTime, distinctUntilChanged, ReplaySubject, Subject, Subscription, take, takeUntil } from 'rxjs';
import { OpentItemsService } from './open-items.service';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { BusinessPartnerService } from 'app/modules/components/business-partners/business-partner/business-partner.service';
import { environment } from 'environments/environment.prod';
import AccountStatementsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/account-statements/account-statements.entity';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import { SalesOfficeService } from 'app/modules/components/configuration/sales-office/sales-office.service';
import { MatDialog } from '@angular/material/dialog';
import { ExportService } from 'app/layout/export-overlay/export-overlay.service';
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from 'app/layout/export-overlay/tasks/core/export-task.interfaces';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { DecimalFormatPipe } from 'app/pipes/decimal-company.pipe';
import { ConfigurationFiltersComponent } from 'app/modules/components/filters/configuration-filters/configuration-filters.component';
import { FilterSectionComponent } from 'app/common/components/filter-section/filter-section.component';
import { BusinessPartnersFiltersComponent } from 'app/modules/components/filters/business-partners-filters/business-partners-filters.component';
import { DatesFiltersComponent } from 'app/modules/components/filters/dates-filters/dates-filters.component';
import { RoutesFiltersComponent } from 'app/modules/components/filters/routes-filters/routes-filters.component';
import { StatusFiltersComponent } from 'app/modules/components/filters/status-filters/status-filters.component';
import { FinanceFiltersComponent } from 'app/modules/components/filters/finance-filters/finance-filters.component';
import { BankAttributes } from '@albatrosdeveloper/ave-models-package';
import { BankService } from 'app/modules/components/payment-master/bank/bank.service';
import { IFilters } from 'app/modules/components/filters/interfaces/filterInterface';
import PaymentConditionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/payment-condition/payment-condition.entity';
import { PaymentConditionService } from 'app/modules/components/master/payment-condition/payment-condition.service';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { MatMenuModule, MatMenuTrigger } from "@angular/material/menu";
import { OpenItemReportExport } from './exports/open-item-report.export';
import { DateHelper } from 'app/utils/date.helper';
import { CompanyCurrencyPipe } from 'app/pipes/currency.pipe';

@Component({
  selector: 'app-open-item',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSidenavModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    FormatOtherDateHourPipe,
    MatSelectModule,
    NgxMatSelectSearchModule,
    FilterComponent,
    DecimalFormatPipe,
    FilterSectionComponent,
    StatusFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    FinanceFiltersComponent,
    HoverMenuDirective,
    MatMenuModule,
    CompanyCurrencyPipe
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    DecimalPipe,
    OpenItemReportExport
  ],
  templateUrl: './open-item.component.html',
  styleUrl: './open-item.component.scss'
})
export class OpenItemComponent implements OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = [
    "businessPartner",
    "document",
    "codeReason",
    "creationDate",
    "expirationDate",
    "availableDays",
    "paymentConditionShort",
    "additionalOC",
    "totalAmount",
    "balance",
    //"statusId"
  ];

  dataSource = new MatTableDataSource<AccountStatementsAttributes>([]);

  totalItems: number = 0;
  search: string = '';
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof AccountStatementsAttributes = "creationDate";
  sortDirection: "ASC" | "DESC" = "DESC"

  filter = {
    dateini: null, //new Date(new Date().setDate(1)),
    salesOffice: null,
    businessPartners: null,
    type: null
  }

  businessPartnerList: BusinessPartnerAttributes[] = [];
  paymentConditionList: PaymentConditionAttributes[] = []
  searchBusiness = ''
  private searchSubjectBusiness = new Subject<string>();

  salesOfficeList: SalesOfficeAttributes[] = [];
  listFilterSalesOfficeList: SalesOfficeAttributes[] = [];
  searchOffice = ''

  bankList: BankAttributes[] = [];
  

  /** control for the selected route for multi-selection */
  public bankMultiCtrl: FormControl<BankAttributes[]> = new FormControl<
    BankAttributes[]
  >([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public bankMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of route filtered by search keyword */
  public filteredBank: ReplaySubject<BankAttributes[]> =
    new ReplaySubject<BankAttributes[]>(1);

  /** local copy of filtered route to help set the toggle all checkbox state */
  protected filteredBankCache: BankAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateBank = false;
  isCheckedBank = false;

  protected _onDestroy = new Subject<void>();

  //BUSCADOR
  searchSubscription: Subscription;


  form: FormGroup;

  loadConfigData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadFinanceData = false;

  constructor(
    private opentItemsService: OpentItemsService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly businessPartnerService: BusinessPartnerService,
    private readonly paymentService: PaymentConditionService,
    private readonly searchService: SearchService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    public exportService: ExportService,
    private openItemReportExport: OpenItemReportExport,
    private fb: FormBuilder,
    private readonly bankService: BankService
  ) {
    this.form = this.fb.group({
      start: [],
      end: [],
      exp_start:[],
      exp_end:[],
      companyId: [],
      salesOfficeId: [],
      subRouteId: [],
      bankId: [],
      paymentConditionId: [],
      customerId:[]
    });
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onFinanceExpanded(): void {
    if(!this.loadFinanceData){
        this.fetchAllBank()
        this.fetchAllPaymentCondition();
    }

    this.loadFinanceData = true;
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.onFilter();

    // this.getAllOfficeList();
    

    // this.setupBusinessSearchControl();
    // this.getAllBusinessPartner();

  }

      private fetchAllPaymentCondition(): void {
    this.paymentService.findToComboBox().subscribe({
      next: (res) => {
        this.paymentConditionList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener condiciones de pago.","Cerrar",{ duration: 5000});
      },
    });
  }

  private fetchAllBank(): void {
    this.bankService.findToComboBox().subscribe({
      next: (res) => {
        this.bankList = res.data;
        this.filteredBank.next(this.bankList)

        // listen for search field value changes
        this.bankMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterBankMulti();
            this.setToggleAllCheckboxStateBank();
          });
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener bancos.","Cerrar",{ duration: 5000});
      },
    });
  }

  protected filterBankMulti() {
    if (!this.bankList) {
      return;
    }
    // get the search keyword
    let search = this.bankMultiFilterCtrl.value;
    if (!search) {
      this.filteredBankCache = this.bankList;
      this.filteredBank.next(this.bankList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar los precios por nombre o código
    this.filteredBankCache = this.bankList.filter((bank) => {
      const nameMatches = bank.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        bank?.externalKeys?.code.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches;
    });
    this.filteredBank.next(this.filteredBankCache);
  }

  toggleSelectAllBank(selectAllValue: boolean) {
    this.filteredBank
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.bankMultiCtrl.patchValue(val);
        } else {
          this.bankMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateBank() {
    let filteredLength = 0;
    if (this.bankMultiCtrl && this.bankMultiCtrl.value) {
      this.filteredBankCache.forEach((el) => {
        if (this.bankMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateBank =
        filteredLength > 0 && filteredLength < this.filteredBankCache.length;
      this.isCheckedBank =
        filteredLength > 0 && filteredLength === this.filteredBankCache.length;
    }
  }

  onFilter() {
    this.getListReport()
  }

  onClearFilter() {
    this.filter = {
      dateini: null,
      salesOffice: null,
      businessPartners: null,
      type: null
    }
    const today = new Date(); 
    this.form.reset({ start: today, end: today });
    this.onFilter()
  }


  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1;
        this.search = term;
        this.getListReport();
      });
  }

  getListReport() {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    // let salesOffice = this.salesOfficeList.find(ele => ele._id == this.filter.salesOffice)

    let filter: IFilters = {
      startDate: DateHelper.getStartOfDay(this.form.get("start")?.value),
      endDate: DateHelper.getEndOfDay(this.form.get("end")?.value) ?? DateHelper.getEndOfDay(this.form.get("start")?.value) ?? null,
      expirationStartDate: DateHelper.getStartOfDay(this.form.get("exp_start")?.value) ??  null,
      expirationEndDate: DateHelper.getEndOfDay(this.form.get("exp_end")?.value) ?? DateHelper.getEndOfDay(this.form.get("exp_start")?.value) ?? null,
      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      customerId:this.form.get("customerId")?.value,
      subRouteId: this.form.get("subRouteId")?.value,//
      bankId: this.form.get("bankId")?.value,
      paymentConditionId: this.form.get("paymentConditionId")?.value,

    }
    this.opentItemsService.findAllWithCount(
      options,
      filter,
      // this.filter.salesOffice ? (salesOffice ? salesOffice._id : null) : null,
      // this.filter.businessPartners ? [this.filter.businessPartners] : [],
      // this.filter.dateini ? new Date(this.filter.dateini).toISOString() : null,
    ).subscribe({
      next: (res: IPaginationResult<AccountStatementsAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener información del reporte.", "Cerrar", { duration: 5000 });
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || 'ASC'
    this.getListReport()
  }

  changePage(e) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getListReport()
  }

  // Función para calcular los días vencidos
  getExpiredDays(expirationDate: Date): number {
    if (!expirationDate) {
      return 0;
    }

    const today = new Date();
    const expiration = new Date(expirationDate);

    today.setHours(0, 0, 0, 0);
    expiration.setHours(0, 0, 0, 0);

    if (isNaN(expiration.getTime())) {
      return 0; // Si la fecha es inválida, retorna 0 o el valor que consideres adecuado
    }

    const timeDifference = today.getTime() - expiration.getTime();
    const dayDifference = timeDifference / (1000 * 3600 * 24);
    return dayDifference > 0 ? Math.floor(dayDifference) : 0;
  }

  openExportSidenav() {
    const id = 'open-items';
    
    // Verificar si ya hay una tarea activa usando el nuevo export
    if (!this.openItemReportExport.canStartTask(id)) {
      return;
    }

    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: {
        title: 'Partidas Abiertas',
      },
    });
    
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        // Usar el nuevo export moderno
        this.openItemReportExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
          id,
          'Partidas Abiertas'
        );
      }
    });
  }

  //filter
  private getAllOfficeList(): void {
    this.salesOfficeService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
        this.listFilterSalesOfficeList = this.salesOfficeList.slice()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener oficinas de venta.","Cerrar",{ duration: 5000});
      },
    });
  }

  changueOptionsOffice(event) {
    if (!this.salesOfficeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSalesOfficeList = this.salesOfficeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSalesOfficeList = this.salesOfficeList.filter(item => item.externalKeys?.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1)
  }

  changeBusiness(event) {
    this.businessPartnerList = []
    this.getAllBusinessPartner(event)
  }

  private getAllBusinessPartner(salesOfficeId?): void {
    const materialOptions = {
      search: this.searchBusiness ? this.searchBusiness : null,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    this.businessPartnerService.findAllWithCount(
      materialOptions,
      false,
      [],
      'both',
       null
    ).subscribe({
      next: (res: IPaginationResult<BusinessPartnerAttributes>) => {
        this.businessPartnerList = res?.data?.[0]?.data ?? [];
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al obtener socios de negocios.', 'Cerrar', { duration: 3000 });
      },
    })
  }

  changueOptionsBusiness(event) {
    this.searchSubjectBusiness.next(event)
  }

  private setupBusinessSearchControl(): void {
    this.searchSubjectBusiness
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((searchTerm) => {
        if (searchTerm) {
          this.searchBusiness = searchTerm;
          this.getAllBusinessPartner();
        }
      });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
